// Module
var code = `<article class="page-item--article">
  <header class="article-header">
    <h2>{{headline}}</h2>
    <p class="article-subheadline">{{subheadline}}</p>
  </header>
  <div class="article-media">
    <img class="article-img" alt="{{attrImageAlt}}" src="{{attrImageSrc}}" />
  </div>
  <div class="article-body">{{contentHTML}}</div>
</article>
`;
// Exports
module.exports = code;